import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Scope } from '@sentry/types';
import { Observable } from 'rxjs';

import { Router } from '@angular/router';
import { AuthService } from '../auth';
import { SentryService } from './sentry.service';

@Injectable({
    providedIn: 'root',
})
export class InitService {
    constructor(
        private authService: AuthService,
        private httpClient: HttpClient,
        private router: Router,
        private sentry: SentryService
    ) {}

    public check() {
        const code = this.getCodeFromUrl();

        return new Observable((subscriber) => {
            if (!code) {
                const isLoggedIn = this.authService.isLoggedIn();
                if (isLoggedIn) {
                    this.sentry.configureScope(
                        this.authService.getUserProfile()
                    );
                } else {
                    this.authService.signOut();
                }

                return subscriber.complete();
            }

            const headers = {
                'Content-Type': 'application/x-www-form-urlencoded',
            };
            const body = `grant_type=authorization_code&client_id=${environment.auth.userPoolWebClientId}&redirect_uri=${environment.auth.callbackUrl}&scope=openid email phone profile aws.cognito.signin.user.admin&code=${code}`;
            const urlOauth2 = `${environment.auth.url}/oauth2/token`;

            return this.httpClient
                .post<{
                    id_token: string;
                }>(urlOauth2, body, { headers })
                .subscribe({
                    next: (response) => {
                        const { id_token } = response;
                        this.authService.setToken(id_token);

                        const redirect = this.authService.getRedirectPath();
                        this.router.navigateByUrl(
                            redirect ?? '/alternative-account'
                        );
                    },
                    error: (error) => {
                        this.sentry.capture(error, (scope: Scope): Scope => {
                            scope.setTag('auth-flow', 'unexpected');
                            scope.setLevel(`warning`);
                            return scope;
                        });
                        this.authService.signOut();
                    },
                })
                .add(() => subscriber.complete());
        });
    }

    private getCodeFromUrl() {
        const rawUrl = window.location.href;
        const url = new URL(rawUrl);
        return url.searchParams.get('code');
    }
}
